import React, { useEffect, useState } from "react";
import adminAccountingApi from "../services/adminAccountingApi";
import "../styles/Admin.css";

export default function AdminTaxSummaryPage({ adminEmail, onLogout }) {
  const [status, setStatus] = useState({ type: "", msg: "" });
  const [dateFrom, setDateFrom] = useState("");
  const [dateTo, setDateTo] = useState("");
  const [branchId, setBranchId] = useState("");
  const [data, setData] = useState({ total: 0, byBranch: [], account: null });
  const [loading, setLoading] = useState(false);

  async function load() {
    setStatus({ type: "", msg: "" });
    setLoading(true);
    try {
      const res = await adminAccountingApi.getTaxSummary({
        dateFrom: dateFrom || undefined,
        dateTo: dateTo || undefined,
        branchId: branchId || undefined,
      });
      if (!res?.ok) throw new Error(res?.error || "load_failed");
      setData({ total: res.total || 0, byBranch: res.byBranch || [], account: res.account || null });
    } catch {
      setStatus({ type: "error", msg: "Unable to load tax summary." });
      setData({ total: 0, byBranch: [], account: null });
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    load();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function money(v) {
    const n = Number(v || 0);
    return Number.isFinite(n) ? n.toFixed(2) : "0.00";
  }

  return (
    <section className="ucx-section">
      <div className="ucx-container ucx-admin-page">
        <div className="ucx-admin-header">
          <div>
            <h1 className="ucx-admin-title">Tax Summary</h1>
            <p className="ucx-admin-subtitle">Sales tax payable postings</p>
          </div>

          <div className="ucx-admin-header-right">
            {adminEmail && <span className="ucx-small">Signed in as {adminEmail}</span>}
            <div className="ucx-admin-header-actions">
              <button className="ucx-btn ucx-btn-outline" type="button" onClick={load} disabled={loading}>
                {loading ? "Refreshing…" : "Refresh"}
              </button>
              {typeof onLogout === "function" ? (
                <button type="button" className="ucx-admin-btn ucx-admin-btn-reject" onClick={onLogout}>
                  Sign out
                </button>
              ) : null}
            </div>
          </div>
        </div>

      <div className="ucx-admin-table-wrapper">
          <table className="ucx-admin-table">
            <thead>
              <tr>
                <th>Branch</th>
                <th>Total tax</th>
              </tr>
            </thead>
            <tbody>
              {(data.byBranch || []).map((b) => (
                <tr key={b.branch_id}>
                  <td>{b.branch_id === 0 ? "N/A" : b.branch_id}</td>
                  <td>{money(b.total)}</td>
                </tr>
              ))}

              {loading && (
                <tr>
                  <td colSpan={2} className="ucx-admin-empty">
                    Loading tax summary…
                  </td>
                </tr>
              )}

              {!loading && (data.byBranch || []).length === 0 && (
                <tr>
                  <td colSpan={2} className="ucx-admin-empty">
                    No breakdown found for these filters.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
}
